import React from "react"
import PropTypes from "prop-types"
import theme from "styles/theme"

export const containerMaxWidth = 1440

const Container = ({
  id,
  max = containerMaxWidth,
  wrapperStyles = {},
  wrapperClassName,
  ...props
}) => (
  <section
    css={[
      !wrapperStyles.backgroundColor && {
        ":nth-of-type(odd)": {
          backgroundColor: theme.nearWhite,
        },
        ":nth-of-type(even)": {
          backgroundColor: theme.lightGray,
        },
      },
      wrapperStyles,
    ]}
    className={wrapperClassName}
    id={id}
  >
    <div css={{ maxWidth: max, margin: "0 auto" }} {...props} />
  </section>
)

export default Container

Container.propTypes = {
  id: PropTypes.string,
  max: PropTypes.any,
  wrapperStyles: PropTypes.object,
  wrapperClassName: PropTypes.string,
}
